/**
 * CAPA DE DATOS (DL): SLOT MACHINE
 * Se comunica con los endpoints de la API de la Tragamonedas.
 */

const PrepareScreen = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/PrepareScreen/${screenId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al preparar la pantalla.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData };

    } catch (error) {
        return { success: false, message: 'Error de conexión con el servidor.' };
    }
};

const ExecuteSpin = async (dataPayload) => {
    try {
        const requestBody = {
            //screenId: dataPayload.screenId,
            targetScreenId: dataPayload.targetScreenId,
            // winProbability: dataPayload.winProbability,
            // baseTimeMs: dataPayload.baseTimeMs,
            // celebrationTimeMs: dataPayload.celebrationTimeMs,
            // symbols: dataPayload.symbols,
            playerName: dataPayload.playerName || 'Anónimo',
            playerContact: dataPayload.playerContact || ''
        };

        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/Spin`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody)
        });
        
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return { success: false, message: errorData.message || 'Error al ejecutar el giro.' };
        }
        
        const responseData = await response.json();
        return { success: true, data: responseData };

    } catch (error) {
        return { success: false, message: 'Error de red al intentar girar la máquina.' };
    }
};

const ToggleQROverlay = async (targetScreenId, isVisible) => {
    try {
        const dataToSend = {
            TargetScreenId: targetScreenId,
            IsVisible: isVisible
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/ToggleQR`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        });

        if (!response.ok) throw new Error('Error al conmutar QR');

        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

const ToggleThanksOverlay = async (targetScreenId, isVisible) => {
    try {
        const dataToSend = {
            TargetScreenId: targetScreenId,
            IsVisible: isVisible
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/ToggleThanks`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataToSend)
        });

        if (!response.ok) throw new Error('Error al conmutar Agradecimiento');

        return { success: true };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

const EnterMachineView = async () => {
    try {
        // Llama al endpoint que pusimos en AdminController.cs
        const response = await fetch(`${process.env.REACT_APP_API_URL}Admin/SlotMachine/Enter`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!response.ok) throw new Error('Error al entrar');
        
        return { success: true };
    } catch (error) {
        return { success: false };
    }
};

const SaveConfig = async (configData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/SaveConfig`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(configData)
        });
        if (!response.ok) throw new Error('Error al guardar configuración');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

const GetConfig = async (targetScreenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/GetConfig/${targetScreenId}`);
        if (!response.ok) throw new Error('No se encontró configuración');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

// Asumiendo que tienes un endpoint para listar las pantallas del evento
const GetScreens = async () => {
    try {
        // Ajusta esta URL al endpoint que devuelve tus pantallas (Ej: Event/Screens o Admin/Screens)
        // Si no tienes uno específico para la tragamonedas, usa el general de pantallas
        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/GetScreens`);
        if (!response.ok) throw new Error('Error al obtener pantallas');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message, data: [] };
    }
};

const CreateScreen = async (name) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/AddScreen`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ eventId: 1, name: name })
        });
        if (!response.ok) throw new Error('Error al crear pantalla');
        return await response.json();
    } catch (error) {
        return { success: false, message: error.message };
    }
};

const DeleteScreen = async (screenId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/DeleteScreen/${screenId}`, { method: 'DELETE' });
        if (!response.ok) throw new Error('Error al eliminar pantalla');
        return await response.json();
    } catch (error) { return { success: false, message: error.message }; }
};

const IdentifyScreens = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}SlotMachine/IdentifyScreens`, { method: 'POST' });
        if (!response.ok) throw new Error('Error al enviar señal de identificación');
        return await response.json();
    } catch (error) { return { success: false, message: error.message }; }
};

export { PrepareScreen, ExecuteSpin, ToggleQROverlay, ToggleThanksOverlay, EnterMachineView, SaveConfig, GetConfig, GetScreens, CreateScreen, DeleteScreen, IdentifyScreens };